import { c as _c } from "react/compiler-runtime";
import { BenefitTiles } from '@/components/tiles';
import { IconTile } from '@/components/IconTile';
import { SectionHeadline } from '@/components/SectionHeadline';
import React from 'react';
import { useTranslation } from 'react-i18next';
import IconExtend from '@/assets/icons/heroIcons/Extend.svg';
import IconGift from '@/assets/icons/heroIcons/Gift.svg';
import IconShoppingBag from '@/assets/icons/heroIcons/Shopping-bag.svg';
import IconShieldCheck from '@/assets/icons/heroIcons/ShieldCheck.svg';
export function Gifts() {
  const $ = _c(32);
  const {
    t
  } = useTranslation("springOffer");
  let t0;
  if ($[0] !== t) {
    t0 = t("spring.gifts.title");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <SectionHeadline className="mx-auto mb-10 px-0 lg:mb-16" anchorKey="spring.gifts.title">{t0}</SectionHeadline>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("spring.gifts.items.1");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <IconTile icon={<IconExtend />} />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2) {
    t4 = {
      title: t2,
      icon: t3
    };
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("spring.gifts.items.2");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <IconTile icon={<IconGift />} />;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5) {
    t7 = {
      title: t5,
      icon: t6
    };
    $[12] = t5;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t("spring.gifts.items.3");
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <IconTile icon={<IconShoppingBag />} />;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t8) {
    t10 = {
      title: t8,
      icon: t9
    };
    $[17] = t8;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t) {
    t11 = t("spring.gifts.items.4");
    $[19] = t;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <IconTile icon={<IconShieldCheck />} />;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t11) {
    t13 = {
      title: t11,
      icon: t12
    };
    $[22] = t11;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t10 || $[25] !== t13 || $[26] !== t4 || $[27] !== t7) {
    t14 = <BenefitTiles background="bg-blue-50" items={[t4, t7, t10, t13]} />;
    $[24] = t10;
    $[25] = t13;
    $[26] = t4;
    $[27] = t7;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t1 || $[30] !== t14) {
    t15 = <div className="px-4">{t1}{t14}</div>;
    $[29] = t1;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  return t15;
}